const Id = {
    ids : function(){
        if(!Id._ids)
            Id._ids= {};
        return Id._ids;
    },

    getID : function(){
        var newId = Id.UID();
        if(Id.ids[newId] == undefined)
        {
            Id.ids[newId] = newId;
            return newId;
        }
        return Id.getID();
    },

    s4 : function(){
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    },

    UID : function(){
        return "UID_" + Id.s4() + Id.s4();
    }
}

module.exports = Id;


// WEBPACK FOOTER //
// ./src/control/util/Id.js